import { render, staticRenderFns } from "./list-tab.vue?vue&type=template&id=0c108423"
import script from "./list-tab.vue?vue&type=script&lang=js"
export * from "./list-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports